import React, { useState, useEffect, useRef, useMemo } from "react";
import numberToWords from "number-to-words";
import styled from 'styled-components'
import '../../../assets/styles/admin/quotation_print.scss'
import { AnyARecord } from "dns";
import { string } from "prop-types";



interface Props {
    data?: any;
    payment?: any;
    refPrint?: any;
}

const Print: React.FC<Props> = ({ data, payment, refPrint }) => {
    const NumberFormat = (number: number) => {
        return new Intl.NumberFormat().format(number)
    }
    const amount = data?.treatments?.reduce((total: number, item: any) => {
        return total + (item?.price * item?.quantity)
    }, 0) || 0;
    const discount = data?.treatments?.reduce((total: number, item: any) => {
        return total + parseInt(item?.discount)
    }, 0) || 0;

    const BAHTTEXT: string | any = (num: number | string, suffix: string) => {
        if (typeof suffix === 'undefined') {
            suffix = 'บาทถ้วน';
        }
        num = num || 0;
        let StrNum = num.toString().replace(/[, ]/g, '');
        if (isNaN(parseFloat(StrNum)) || (Math.round(parseFloat(StrNum) * 100) / 100) === 0) {
            return 'ศูนย์บาทถ้วน';
        } else {
            var t = ['', 'สิบ', 'ร้อย', 'พัน', 'หมื่น', 'แสน', 'ล้าน'],
                n = ['', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า'],
                len,
                digit,
                text = '',
                parts: string[] | any,
                i;

            if (StrNum.indexOf('.') > -1) {

                parts = StrNum.toString().split('.');

                num = parts[0];
                parts[1] = parseFloat('0.' + parts[1]);
                parts[1] = (Math.round(parts[1] * 100) / 100).toString(); // more accurate than toFixed(2)
                parts = parts[1].split('.');

                if (parts.length > 1 && parts[1].length === 1) {
                    parts[1] = parts[1].toString() + '0';
                }

                num = parseInt(num.toString(), 10) + parseInt(parts[0], 10);

                text = num ? BAHTTEXT(num) : '';

                if (parseInt(parts[1], 10) > 0) {
                    text = text.replace('ถ้วน', '') + BAHTTEXT(parts[1], 'สตางค์');
                }
                return text;
            } else {
                if (StrNum.length > 7) {
                    var overflow = StrNum.substring(0, StrNum.length - 6);
                    var remains = StrNum.slice(-6);
                    return BAHTTEXT(overflow).replace('บาทถ้วน', 'ล้าน') + BAHTTEXT(remains).replace('ศูนย์', '');

                } else {

                    len = StrNum.length;
                    for (i = 0; i < len; i = i + 1) {
                        digit = parseInt(StrNum.charAt(i), 10);
                        if (digit > 0) {
                            if (len > 2 && i === len - 1 && digit === 1 && suffix !== 'สตางค์') {
                                text += 'เอ็ด' + t[len - 1 - i];
                            } else {
                                text += n[digit] + t[len - 1 - i];
                            }
                        }
                    }
                    text = text.replace('หนึ่งสิบ', 'สิบ');
                    text = text.replace('สองสิบ', 'ยี่สิบ');
                    text = text.replace('สิบหนึ่ง', 'สิบเอ็ด');

                    return text + suffix;
                }
            }
        }
    }
    const TablePrint = styled.table`
        font-family: arial, sans-serif;
        border-collapse: collapse;
        width: 100%;
        margin-bottom: 1.2rem;
        tbody {
            border: 1px solid rgb(91, 174, 169) !important;
          }
          
          td,
          th {
            border-right: 1px solid rgb(91, 174, 169) !important;
            border-left: 1px solid rgb(91, 174, 169) !important;
            text-align: center;
            padding: 8px;
            &:nth-child(odd) {
                border: 1px solid rgb(91, 174, 169) !important;
            }
          }
    `

    return (
        <div
            ref={refPrint}
            style={{
                padding: '1rem',
                background: '#ffff',
                borderRadius: '1rem'
            }}>
            <div className="report-header">
                <div style={{
                    display: 'flex'
                }}>
                    <div style={{
                        width: '70%',
                        maxWidth: '70%'
                    }}>
                        <div className="logo text-left">
                            <img src="data:image/png;base64,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" className="logo" />
                        </div>
                        <p className="bold">บริษัท เดอมาสเตอร์ จำกัด 342/1, 342/2 ซอยสุขุมวิท 63 (เอกมัย) แขวงคลองตันเหนือ เขตวัฒนา กรุงเทพ ฯ 10110</p>
                        <p className="bold">โทร 02-714-4471 แฟกซ์ 02-714-4001 เลขประจำตัวผู้เสียภาษี 01055554026949</p>
                        <p>Dermaster Company Limited42 Ekamai Rd, Klongton Nua, Wattana, Bangkok, Thailand 10110</p>
                        <p>Tel. 02 71-444-71 Fax. 02-714-4001</p>
                        <p>Tax ID No. 01055554026949</p>
                    </div>
                    <div style={{
                        width: '30%',
                        maxWidth: '30%',
                        height: 'max-content',
                        margin: 0,
                        display: 'grid',
                        justifyItems: 'end'
                    }}>
                        <div style={{
                            width: '70%',
                            textAlign: 'center',
                            border: '1px solid rgb(91, 174, 169)',
                            padding: '10px 25px',
                            borderRadius: '8px'
                        }}>
                            <p>ต้นฉบับใบกำกับภาษี</p>
                            <p>Original Tax Invoice</p>
                        </div>
                        <div style={{
                            marginTop: '20px',
                            textAlign: 'center'
                        }}>
                            <p>วันที่/Date : 18/01/2021</p>
                            <p>ใใบแจ้งหนี้เลขที่/Tax Invoice No.</p>
                            <p>{data?.code}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="report-body">
                <div style={{
                    display: 'flex'
                }}>
                    <div style={{
                        width: '50%',
                        maxWidth: '50%'
                    }}>
                        <p>ลูกค้า/Customer : {data?.customer}</p>
                        <p>ลูรหัสลูกค้า/CN : {data?.customerCode}</p>
                        <p>เลขที่ใบยา/Ref. : {data?.vn}</p>
                        <p>ผู้ขาย/Consult : {data?.consults?.map((item: any) => <span>{item?.displayName} , </span>)}</p>
                    </div>
                    <div style={{
                        width: '50%',
                        maxWidth: '50%',
                        height: 'max-content',
                        margin: 0,
                        display: 'grid',
                    }}>
                        <p>ที่อยู่ออกบิล/Billing Address :</p>
                        <p> {data?.billingAddress}</p>
                    </div>
                </div>
                <TablePrint>
                    <tr style={{
                        border: '1px solid rgb(91, 174, 169)'
                    }}>
                        <th>ลำดับที่/No.</th>
                        <th>รายการ/Description</th>
                        <th>ราคาขาย/Price</th>
                        <th>ส่วนลด/Discount</th>
                        <th>จำนวนเงิน/Amount</th>
                    </tr>
                    {data?.items?.map((item: any, index: number) =>
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td className="border-full">{item?.name}</td>
                            <td>{NumberFormat(item.price)}</td>
                            <td className="border-full">{NumberFormat(item.specialPrice + item.specialDiscount)}</td>
                            <td>{NumberFormat(item.totalPrice)}</td>
                        </tr>
                    )}
                    <tr style={{
                        position: 'relative',
                        borderTop: '1px solid rgb(91, 174, 169)'
                    }}>
                        <th colSpan={3} rowSpan={4} style={{
                            textAlign: 'left',
                            padding: '1rem',
                            verticalAlign: 'top'
                        }}>
                            <div>
                                <p>หมายเหตุ : {data?.note}</p>
                            </div>

                        </th>
                        <td style={{
                            textAlign: "right"
                        }}>รวมเป็นเงิน
                            Amount</td>
                        <td>{NumberFormat(amount)}</td>
                    </tr>
                    <tr>
                        <td style={{
                            textAlign: "right"
                        }}>หักส่วนลด โอนคอร์ส/Filler (Juvederm Vollift)
                            Less Discounteposit</td>
                        <td className="border-full">{NumberFormat(discount)}</td>
                    </tr>
                    <tr>
                        <td style={{
                            textAlign: "right"
                        }}>หักเงินมัดจำ
                            Less Deposit</td>
                        <td className="border-full">{NumberFormat(amount - discount)}</td>
                    </tr>
                    <tr>
                        <td style={{
                            textAlign: "right"
                        }}>รวมทั้งสิ้น
                            Grand Total</td>
                        <td className="border-full">{NumberFormat(amount - discount)}</td>
                    </tr>
                </TablePrint>


                <div className="info">
                    <div style={{
                        display: 'flex'
                    }}>
                        <div style={{
                            width: '100%',
                            maxWidth: '70%'
                        }}>
                            <p>{BAHTTEXT(NumberFormat(amount - discount))} ({numberToWords.toWordsOrdinal(amount - discount)} baht only)</p>
                        </div>
                        <div style={{
                            width: '100%',
                            maxWidth: '30%',
                            height: 'max-content',
                            margin: 0,
                            display: 'grid',
                        }}>
                            <p>Payment : เครดิต, เดบิต/Credit, Debit : 0.00 บาท</p>
                            <p>Payment : เงินสด/Cash : 4,310.00 บาท</p>
                        </div>
                    </div>

                    <hr style={{
                        borderBottom: '1px solid rgb(91, 174, 169)'
                    }} />
                    <div style={{
                        display: 'flex'
                    }}>
                        <div style={{
                            width: '100%',
                            maxWidth: '70%'
                        }}>
                            <p>ยอดคงค้าง
                                Outstanding Balance 0.00 บาท</p>
                        </div>
                        <div style={{
                            width: '100%',
                            maxWidth: '30%',
                            height: 'max-content',
                            margin: 0,
                            display: 'grid',
                        }}>
                            <p>จากราคาเต็มหลังหักส่วนลด
                                From full price after discount 19,310.00 บาท</p>
                        </div>
                    </div>

                    <hr style={{
                        borderBottom: '1px solid rgb(91, 174, 169)'
                    }} />

                    <ul>
                        <li>บริษัทจะรับคืนยาเฉพาะรายการที่มีอาการแพ้ยาซึ่งวินิจฉัยโดยแพทย์เท่านั้น กรุณาเก็บใบเสร็จเป็นหลักฐานในการติดต่อกับบริษัททุกครั้ง
                            Patients may return the medicine only if they have experienced adverse reaction to that medication. Please keep this receipt for reference.</li>
                    </ul>

                    <div style={{
                        width: '100%',
                        display: 'flex'
                    }}>
                        <div style={{
                            width: '50%'
                        }}
                            className="center">
                            <p className="center">____________________________________________</p>
                            <p>ชื่อลูกค้า (Customer Signature)</p>
                        </div>
                        <div style={{
                            width: '50%'
                        }}
                            className="center">
                            <p className="center">____________________________________________</p>
                            <p>( {payment?.createdUser?.displayName}  )</p>
                            <p>เจ้าหน้าที่การเงิน (Cashier)</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Print;
